import React from 'react'
import HttpServices from '../../../utils/Http.services'
import SingleBlogContent from './SingleBlogContent';
import AsideBlog from './AsideBlog';
import SliderBlog from './SliderBlog';
import { siteConfig } from '../../../variables/config'
// import Router from 'next/router';
import { translate } from '../../../utils/useful'
import { Router } from 'react-router-dom';

// import HttpServices from '../../utils/Http.services'


// export async function getServerSideProps(context) {

//     let blogID = context?.query?.blogId;

//     let lng = context.locale
//     if (!lng) {
//         lng = 'en'
//     }


//     const blogsRes = await (await HttpServices.syncRequest('getOneBlog', { _id: blogID })).result
//     const allBlogs = await (await HttpServices.syncRequest('getRecommendedBlogs', { _id: blogsRes?.info?._id, lng })).result
//     const AdsJson = await (await HttpServices.syncRequest('getAllBaners', { filter: { position: { "$in": ["blogs"] } } })).result


//     return {
//         props: JSON.parse(JSON.stringify({
//             blog: blogsRes?.info,
//             allBlogs,
//             ads: AdsJson?.info
//         }))
//     }

// }
export default class SingleBlog extends React.Component {

    state = {
        ads: [
            { src: '/images/video/vid8.jpg' }
        ],
        blog: [
            { title: 'its morshedi & aqdas', body: 'lorem cbjxkacbaljksbcawiho ,ab nk khavskhwvduw jkwhablfj jabdjsbdlql;wkh powjqoprjh  bj a.m,snc. njekvbfdkwhq lhsiaocgnzviwgauwhrip h daksdhniobf ibawbdjb spjd[oeif k;l ' }
        ],
        fullUrl: [
            { href: '#' }
        ],
        blogs: [
            { src: '/images/video/vid3.jpg', title: 'aqdas mohseni', description: 'c,nzlkncaeofnpo jsopenfki naendpown ojeam[gk pdm,cl;d ma;lndop enfopnweonfe ndkncd. ' },
            { src: '/images/video/vid3.jpg', title: 'aqdas mohseni', description: 'c,nzlkncaeofnpo jsopenfki naendpown ojeam[gk pdm,cl;d ma;lndop enfopnweonfe ndkncd. ' },
            { src: '/images/video/vid3.jpg', title: 'aqdas mohseni', description: 'c,nzlkncaeofnpo jsopenfki naendpown ojeam[gk pdm,cl;d ma;lndop enfopnweonfe ndkncd. ' },
            { src: '/images/video/vid3.jpg', title: 'aqdas mohseni', description: 'c,nzlkncaeofnpo jsopenfki naendpown ojeam[gk pdm,cl;d ma;lndop enfopnweonfe ndkncd. ' },
            { src: '/images/video/vid3.jpg', title: 'aqdas mohseni', description: 'c,nzlkncaeofnpo jsopenfki naendpown ojeam[gk pdm,cl;d ma;lndop enfopnweonfe ndkncd. ' },
            { src: '/images/video/vid3.jpg', title: 'aqdas mohseni', description: 'c,nzlkncaeofnpo jsopenfki naendpown ojeam[gk pdm,cl;d ma;lndop enfopnweonfe ndkncd. ' },
            { src: '/images/video/vid3.jpg', title: 'aqdas mohseni', description: 'c,nzlkncaeofnpo jsopenfki naendpown ojeam[gk pdm,cl;d ma;lndop enfopnweonfe ndkncd. ' },
            { src: '/images/video/vid3.jpg', title: 'aqdas mohseni', description: 'c,nzlkncaeofnpo jsopenfki naendpown ojeam[gk pdm,cl;d ma;lndop enfopnweonfe ndkncd. ' },
        ]
    }


    // componentDidMount() {
    //     let fullUrl = siteConfig.rootDomain + Router.router.asPath

    //     // console.log(fullUrl)
    //     this.setState({ fullUrl })
    // }

    render() {
        return (
            <>
                <div className='container my-5'>
                    <div className='d-flex'>
                        <AsideBlog ads={this.state.ads} />
                        <main className='main-content-blog'>
                            <SingleBlogContent blog={this.state.blog} fullUrl={this.state.fullUrl} />
                        </main>
                    </div>
                </div>
                <div className='article-blog-container my-3 container' style={{ textAlign: "center" }}>
                    <h3 className='text-normal mb-5'>{translate(`Latest Articles`)}</h3>
                    {/* <SliderBlog blogs={this.props.allBlogs?.info} fullUrl={this.state.fullUrl} /> */}
                    <SliderBlog blogs={this.state.blogs} fullUrl={this.state.fullUrl} />
                </div>
            </>
        )
    }
}
